<template>
  <div class="details-wrapper">
    <div class="details-header">
      Supplier Contact#{{ getSupplierContact.user.reference_number }}
    </div>
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <h1>{{ this.$t('supplierContacts.labels.details') }}</h1>
            <SupplierContactDetailsForm :supplier-contact="getSupplierContact" />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppActions } from '@/app/app.keys';
import { mapGetters } from 'vuex';
import { SupplierContactGetters, SupplierContactActions } from './supplier-contact-details.keys';
import SupplierContactDetailsForm from '@/app/features/supplier-contacts/features/supplier-contact-details/components/SupplierContactDetailsForm';
export default {
  components: {
    SupplierContactDetailsForm
  },
  data() {
    return {
      sidebarMenu: [
        { label: this.$t('supplierContacts.labels.details') },
        { label: this.$t('supplierContacts.labels.history') }
      ]
    };
  },
  computed: {
    ...mapGetters([SupplierContactGetters.GetSupplierContact])
  },
  mounted() {
    this.$store.dispatch(
      AppActions.SetPageTitle,
      this.$t('supplierContacts.details.supplierContact')
    );
    this.$store.dispatch(SupplierContactActions.GetSupplierContact, this.$route.params.id);
  }
};
</script>
<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 2px solid $row-border;
    justify-content: space-between;
  }
  .details-body {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      margin: 0 auto;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }

    .details-section {
      padding-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }
    }
  }
}
</style>
